module.exports = __webpack_public_path__ + "img/mlh_honor_6.cd725272.png";